module.exports = __webpack_public_path__ + "media/banner/banner-6-2794519e.jpg";